<div class="edit-section-wrapper">
  <mat-drawer-container #matDrawerContainer (backdropClick)="closeBackdrop()">
    <mat-drawer role="navigation" class="left-sidenav-drawer" #leftnav [opened]="leftSideNav">
      <div fxLayout="row">
        <uni-left-sidenav-collapsed (toggle)="closeBackdrop()" [showSidenav]="true" [showDiscoverSection]="false">
        </uni-left-sidenav-collapsed>
        <ng-container *ngTemplateOutlet="sidenavView">
        </ng-container>
      </div>
    </mat-drawer>

    <mat-drawer-content>
      <div class="fixed top-0" style="filter: drop-shadow(rgba(0, 0, 0, 0.1) 0px 0px 50px);" fxLayout="row" *ngIf="!mobileView">
        <uni-left-sidenav-collapsed (toggle)="leftnav.toggle()" [showSidenav]="true" [showDiscoverSection]="false">
        </uni-left-sidenav-collapsed>
        <ng-container *ngIf="desktopView">
          <ng-container *ngTemplateOutlet="sidenavView">
          </ng-container>
        </ng-container>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
<main class="main">
  <router-outlet></router-outlet>
</main>


<ng-template #sidenavView>
  <div class="sidenav padding-y-2 relative">
    <p class="title margin-bottom-5 margin-top-0 margin-x-3 font-bolder">Journal Editor</p>
    <ng-container *ngFor="let section of sections; let i=index">
      <div class="section-border">
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="currentIndex==i">
          <mat-expansion-panel-header style="padding: 0 12px; border-radius: unset;" (click)="goToRoute(section.id)">
            <mat-panel-title class="margin-0 sparro-grey-800" fxLayout="start center">
              <i [class]="section.icon + ' icons'"></i>
              <p class="margin-0 font-bold" style="font-size: 16px; ">{{section.title}}</p>
            </mat-panel-title>

          </mat-expansion-panel-header>
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px"
            *ngFor="let subsection of section.subSections" class="inner-section">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
              <i [class]="subsection.icon + ' icons'"></i>
              <p class="margin-0 sparro-grey-800">
                {{ subsection.title }}
              </p>
            </div>
            <div class="checkbox-section"
              [ngClass]="{'border-required' : subsection.required,'border-added' : subsection.added}">
              <i *ngIf="subsection.added" class="icon-tick-bold"></i>
              <p *ngIf="!subsection.added"
                [ngClass]="{'default' : !subsection.required, 'required' : subsection.required}"></p>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </ng-container>
    <ng-container *ngIf="sidenavBottomLink">
      <a [href]="sidenavBottomLink" target="_blank" class="absolute sparro-bg-grey-100 bottom-0 no-decor padding-2 width-100"
        fxLayout="row" fxLayoutAlign="space-between center">
        <p class="margin-0 font-xxs-static sparro-green-800">Protips for writing outstanding articles</p>
        <i class="icon-open-in-new-tab-bold font-md sparro-green-800"></i>
      </a>
    </ng-container>
  </div>

</ng-template>